import {BasicSearchType} from "../../types/common/basic";
import {DefaultResType, ErrorType, ResponseResType, SuccessType,} from "../../types/common/response";
import {
    RmaDetailItemType,
    RmaListType,
    RmaRequestType,
    RmaResponseType,
    StdType,
    UpdateRmaRequestType,
} from "../../types/support";
import {baseApi} from "../../util/axiosConfig";

const url = "api/customer/support/rma/";

/**
 * RMA 생성하기
 */
export async function createRmaApi(
    data: RmaRequestType
): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(url + "create_rma", data);
    return response?.data;
}

/**
 * RMA 번호 발급하기
 */
export async function createRmaCodeApi(): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(url + "create_rma_code");
    return response?.data;
}

/**
 * RMA 삭제하기
 * @param data
 * @returns
 */
export async function deleteRmaApi(data: {
    rmaIdList: number[];
}): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(url + "delete_rma", data);
    return response?.data;
}

/**
 * RMA excel 내보내기
 * @param data
 * @returns
 */
export async function exportRmaDetailExcelApi(data: {
    rmaId: number;
}): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_rma_detail_excel", data, {
        responseType: "blob",
    });

    return response?.data;
}

/**
 * RMA excel 양식 내보내기
 * @param data
 * @returns
 */
export async function exportRmaExcelFormApi(): Promise<
    Blob | ArrayBuffer | Uint8Array | string | ErrorType
> {
    const response = await baseApi.post(url + "export_rma_excel_form", null, {
        responseType: "blob",
    });

    return response?.data;
}

/**
 * RMA 목록 엑셀 내보내기
 * @param data
 * @returns
 */
export async function exportRmaListExcelApi(
    data: BasicSearchType
): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_rma_list_excel", data, {
        responseType: "blob",
    });

    return response?.data;
}

/**
 * RMA 목록 조회
 * @param data
 * @returns
 */
export async function readRmaApi(
    data: BasicSearchType
): Promise<
    ResponseResType<{ rmaList: RmaListType[]; totalCount: number }> | ErrorType
> {
    const response = await baseApi.post(url + "read_rma", {
        ...data,
        endAt: data?.endAt + " 23:59:59",
    });
    return response?.data;
}

/**
 * RMA 상세 조회
 * @param data
 * @returns
 */
export async function readRmaDetailApi(data: {
    rmaId: number;
}): Promise<ResponseResType<RmaResponseType> | ErrorType> {
    const response = await baseApi.post(url + "read_rma_detail", data);
    return response?.data;
}

/**
 * 규격 조회하기
 * @param data
 * @returns
 */
export async function readStndApi(data: BasicSearchType): Promise<
    | ResponseResType<{
    stndList: StdType[];
    totalCount: number;
}>
    | ErrorType
> {
    const response = await baseApi.post(url + "read_stnd", data);
    return response?.data;
}

/**
 * RMA 수정
 * @param data
 * @returns
 */
export async function updateRmaApi(
    data: UpdateRmaRequestType
): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(url + "update_rma", data);
    return response?.data;
}

/**
 * RMA 상태 변경하기
 * @param data
 * @returns
 */
export async function updateRmaStateApi(data: {
    questionState: string;
    rmaId: number;
}): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(url + "update_rma_state", data);
    return response?.data;
}

/**
 * RMA 엑셀 가져오기
 * @param formData
 * @returns
 */
export async function uploadRmaDetailExcelApi(
    formData: FormData
): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(
        url + "upload_rma_detail_excel",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response?.data;
}

/**
 * 시리얼번호 검증
 * @param data
 * @returns
 */
export async function verifySerialNumberApi(data: {
    barcode: string;
}): Promise<ResponseResType<{ result: boolean }> | ErrorType> {
    const response = await baseApi.post(url + "verify_serial_number", data);
    return response?.data;
}

/**
 * 출고 serial no 조회
 * @param data
 * @returns
 */
export async function readOutgoingSerial(data: BasicSearchType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_outgoing_serial", data);
    } catch (err: any) {
        return err?.response;
    }
}

/**
 * 출고 serial no 엑셀 가져오기
 * @param data
 * @returns
 */
export async function uploadRmaDetailExcel(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_rma_detail_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

/**
 * rma 생성 시 시리얼 번호 검증
 * @param data
 * @returns
 */
export async function verifySerialNumber(data: RmaDetailItemType[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "verify_serial_number", data);
    } catch (err: any) {
        return err?.response;
    }
}

/**
 * 담당자, 요청자 조회
 * @param data
 * @returns
 */
export async function readHandlerDataApi(): Promise<
    ResponseResType<any> | ErrorType
> {
    const response = await baseApi.post(url + "read_handler_data" );
    return response?.data;
}

/*
export async function readUserDataApi(): Promise<ResponseResType<any> | ErrorType> { // hesu ✅ 추가된 부분
    const response = await baseApi.post(url + "read_user_data", {});
    return response?.data;
}
* */

/**
 * 연락처 리스트
 * @param data
 * @returns
 */
export async function readUserDataApi(
    data: any & { accountId: string }
  ): Promise<ResponseResType<SearchContactMapType> | ErrorType> { // hesu ✅ 추가된 부분 .. 인데 type 이 any 임 수정 요망
    const response = await baseApi.post(url + "read_user_data", data);
    return response?.data;
  }

  export interface SearchContactType {
    userId: string;
    userName: string;
    contactNo: string;
    loginId: string;
    title: string;
}

export interface SearchContactMapType {
    userVOList: SearchContactType[];
    totalCount: number
}